<template>
  <div class="form-area">
    <div class="form-title">
      請輸入電郵中的六位數字驗證碼</br>Please enter the six-digit verification code from the email.
    </div>

    <el-row :gutter="10" class="email-row">
      <el-col :span="6">
        <div class="form-label">驗證碼 *</br>Verification code</div>
      </el-col>
      <el-col :span="12">
        <verify-code-input-vue v-model="codeValue" />
      </el-col>
    </el-row>


    <div class="btn-box">
      <el-button class="next-btn" type="warning" round @click="handleVerify">驗證 Verify</el-button>
    </div>
  </div>
</template>

<script>
import {
  continueFillForm,
  create,
  queryFormStatus,
  queryFormData,
} from "@/assets/js/api.js";
import VerifyCodeInputVue from "./verifyCodeInput.vue";
import { setFormDataToCache } from "@/utils/json/utils";
export default {
  components: {
    VerifyCodeInputVue,
  },
  data() {
    return {
      codeValue: "",
      setepName: this.$store.getters.querySetepInfo.currentStepName,
    };
  },

  methods: {
    //验证通过后跳转至下一状态
    handleVerify() {
      if (!this.codeValue) {
        this.$message.warning("請輸入驗證碼");
        return;
      }
      if (this.setepName == "apply") {
        //初次申请
        // 调用后台API校验验证码是否正确，正确则提交个人信息并获取token
        var personalInfo = this.Session.get("personalInfo");
        let params = {
          code: this.codeValue,
          formId: this.Session.get("formId"),
          formName: this.Session.get("formName"),
          verifyEmail: this.Session.get("verifyEmail"),
          personalInfo: JSON.stringify(personalInfo),
        };
        create(params).then((res) => {
          this.$store.dispatch("setToken", res);
          this.Session.set("applyCode", res.applyCode);
          if (res.token) {
            this.$store.dispatch("NEXT_STEP", {
              changeStep: true,
              operateName: "liveEmployment",
            });
            this.$message.success("驗證通過");
          }
        });
      }
      if (this.setepName == "query") {
        //查詢申請狀態
        var queryParams = this.Session.get("queryParams");
        queryParams.code = this.codeValue;
        queryFormStatus(queryParams).then((res) => {
          if (res) {
            //將查詢結果存入session
            this.Session.set("queryResult", res);
            this.$store.dispatch("NEXT_STEP", {
              changeStep: true,
              operateName: "queryResult",
            });
          }
        });
      }
      if (this.setepName === "continue") {
        //繼續填寫申請
        //获取token
        let param = {
          verifyEmail: this.Session.get("verifyEmail"),
          code: this.codeValue,
        };
        continueFillForm(param).then((res) => {
          this.$store.dispatch("setToken", res);
          this.Session.set("applyCode", res.applyCode);
          if (res.token) {
            //查詢個人表單信息並存入緩存
            queryFormData().then((res) => {
              //該接口拿到的信息是後續所有表單信息
              let allFormData = res;
              if (allFormData) {
                //將所有表單信息放入緩存
                setFormDataToCache(allFormData);
                //跳轉
                this.$message.success("驗證通過");
                this.$store.dispatch("NEXT_STEP", {
                  changeStep: true,
                  operateName: "liveEmployment",
                });
              }
            });
          }
        });
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/common/emailVerify.vue